import { Flex, Image, Text, VStack } from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useRef } from 'react';

import { NoFeeGuarantee } from '../../../../../assets/Images';
import TextWithTooltip from '../../../../../components/TextWithTooltip';
import { COUNTRY_CONFIG } from '../../../../../constants/countries';
import { Country } from '../../../../../gql/generated/graphql';
import { formatMoney } from '../../../../../utils/helpers';
import { getEstimatedOverageFee } from '../../../../../utils/mileageWarnings';

const OverMileageFeeWarning = ({
  isModal,
  mileage,
  country,
}: {
  isModal?: boolean;
  mileage: number;
  country: Country;
}) => {
  const estimatedFee = getEstimatedOverageFee(mileage, country);
  const { feeCopy } = COUNTRY_CONFIG[country].odometer;
  const ldClient = useLDClient();

  const alreadyRan = useRef(false);
  useEffect(() => {
    if (!alreadyRan.current) {
      ldClient?.track('over-mileage-warning', {});
      alreadyRan.current = true;
    }
  }, []);

  return (
    <VStack mt={isModal ? 0 : 4}>
      <Flex
        gap="20px"
        my="12px"
        alignItems={{ base: 'center', md: isModal ? 'start' : 'end' }}
        flexDirection={{ md: 'row' }}
      >
        <Image
          ml="10px"
          src={NoFeeGuarantee}
          alt="No Fee Guarantee"
          display={{ base: 'none', md: 'block' }}
          boxSize="115px"
          borderRadius="50%"
          transform="rotate(-10deg)"
          bgGradient="linear(to-br, white, rgb(0, 0, 0, 0.2))"
          boxShadow="2px 2px 6px rgb(0, 0, 0, 0.2)"
        />
        <Flex flexDir="column" textAlign="left" gap="14px">
          {!isModal && (
            <Text color="leaseEndBlue" fontWeight="bold" fontSize="16px">
              Dealership Fee Alert!
            </Text>
          )}
          <Text maxW="container.sm">
            The <b>dealership</b> could charge you{' '}
            <Text as="b" color="leaseEndRed">
              {formatMoney(estimatedFee)}
            </Text>{' '}
            in {feeCopy.overageFees} if you return your car to them!
          </Text>
          <Flex gap="5px" alignItems="center" justifyContent="left">
            <Text>
              But don't worry, there are <b>{feeCopy.noOverageFees}</b> when you buy your car out
              with Lease End.
            </Text>
            <Image
              mr="20px"
              src={NoFeeGuarantee}
              alt="No Fee Guarantee"
              display={{ base: 'block', md: 'none' }}
              boxSize="75px"
              borderRadius="50%"
              transform="rotate(-10deg)"
              bgGradient="linear(to-br, white, rgb(0, 0, 0, 0.2))"
              boxShadow="1px 2px 6px rgb(0, 0, 0, 0.2)"
            />
          </Flex>
        </Flex>
      </Flex>
      <TextWithTooltip label={feeCopy.calculation}>How is this calculated?</TextWithTooltip>
    </VStack>
  );
};

export default OverMileageFeeWarning;
